import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { images } from "../../helpers/images";
import { onClickResetPassword } from "../../modules/actions/";
import { authUserData } from "../../helpers";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      email: "",
      disableSubmit: false,
    };
  }

  componentDidMount() {
    const userData = authUserData();

    if (userData && userData.accessToken) {
      this.props.history.push("/dashboard");
    }
  }

  onChangeHandelUserInput = (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;

    this.setState({
      [name]: value,
    });
  };

  onClickResetPasssword = () => {
    this.setState({ disableSubmit: true });

    this.props.onClickResetPassword({
      email: this.state.email,
    });

    setTimeout(() => this.setState({ disableSubmit: false }), 2500);
  };

  onTextKeyPress = (evt) => {
    if (evt.key === "Enter") {
      this.onClickSignin(evt);
    }
  };

  render() {
    const { email, disableSubmit } = this.state;

    return (
      <div className="grid-container full">
        <div className="grid-x  grid-margin-x" id="container">
          <div className="cell small-12 medium-5" id="infoplatesection">
            <div id="logosection">
              <img src={images.logo} />
            </div>

            <div id="infotxt">
              A few clicks away <br />
              from creating your SAQ
            </div>

            <div id="infobutton">
              <Link to="/signup">
                <button className="button register" id="registerBtn">
                  Sign up
                </button>
              </Link>
              <p> or </p>{" "}
              <Link to="/signin">
                <button className="button login" id="loginBtn">
                  Sign in
                </button>
              </Link>
            </div>
            <div style={{ textAlign: "center", marginTop: "35px" }}>
              <Link to="/forgot-password">
                <button
                  style={{
                    color: "#ffffff",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Forgot Password
                </button>
              </Link>
            </div>
          </div>
          <div className="cell small-12 medium-7" id="formsection">
            <div id="forgotpasswordsaq" className="show">
              <h3>Forgot Password</h3>
              <p>Reset your password</p>
              {/* <p className="smalltxt">
                Let’s get you all setup so you can verify your personal account
                and begin creating SAQ
              </p> */}

              <ToastContainer />

              <div className="grid-container" id="formfieldscontainer">
                <div className="grid-y grid-x">
                  <div className="small-12 medium-8 cell">
                    <label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter email"
                        name="email"
                        value={email}
                        onChange={(evt) => this.onChangeHandelUserInput(evt)}
                        onKeyPress={(evt) => this.onTextKeyPress(evt)}
                      />
                    </label>
                  </div>
                </div>
                <div id="fieldbuttons">
                  {/* <button className="button nxt-btn">Create Account</button> */}
                  <button
                    className="button nxt-btn"
                    onClick={() => this.onClickResetPasssword()}
                    disabled={disableSubmit}
                  >
                    Reset Password
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ onClickResetPassword }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
